import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=801698da&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=801698da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801698da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('801698da')) {
      api.createRecord('801698da', component.options)
    } else {
      api.reload('801698da', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=801698da&scoped=true", function () {
      api.rerender('801698da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/widgets/basic_image/edit.vue"
export default component.exports